/* Elite Sports Equipment — collection page (esh-collection section), 26-9-2026.
   Type groups, price bands, size finder, sort, load more and compare — all on the full product list of the collection. */
(function () {
  'use strict';
  var root = document.querySelector('[data-esc]');
  if (!root) return;
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var grid = $('[data-esc-grid]');
  if (!grid) return;
  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
  var cards = [];
  var groups = [];          // {key,label,kw[],prio,auto,count}
  var groupByKey = {};
  var state = { groups: [], price: '', sort: 'best', finder: null, shown: perPage };
  var bands = { '0-2500': 'Under £25', '2500-10000': '£25 – £100', '10000-50000': '£100 – £500', '50000-': '£500 and over' };

  /* ---------- groups ---------- */
  function titleCase(s) { return s.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
  function buildGroups() {
    var defs = $$('[data-esc-group-def]');
    if (defs.length) {
      groups = defs.map(function (d, i) {
        return { key: d.getAttribute('data-key'), label: d.getAttribute('data-label'), kw: d.getAttribute('data-kw').split(',').map(function (k) { return k.trim(); }).filter(Boolean), prio: parseInt(d.getAttribute('data-prio'), 10) || 10, order: i, auto: false, count: 0 };
      });
    } else {
      var tally = {};
      cards.forEach(function (c) { var t = (c.getAttribute('data-type') || '').trim().toLowerCase(); if (t) tally[t] = (tally[t] || 0) + 1; });
      groups = Object.keys(tally).filter(function (t) { return tally[t] >= 2; }).sort(function (a, b) { return tally[b] - tally[a]; }).slice(0, 8)
        .map(function (t, i) { return { key: t.replace(/[^a-z0-9]+/g, '-'), label: titleCase(t), kw: [t], prio: 10, order: i, auto: true, count: 0 }; });
    }
    groupByKey = {};
    groups.forEach(function (g) { groupByKey[g.key] = g; });
  }
  function assign(card) {
    var t = card.getAttribute('data-t');
    var type = (card.getAttribute('data-type') || '').trim().toLowerCase();
    var ranked = groups.slice().sort(function (a, b) { return a.prio - b.prio || a.order - b.order; });
    for (var i = 0; i < ranked.length; i++) {
      var g = ranked[i];
      if (g.auto ? type === g.kw[0] : g.kw.some(function (k) { return t.indexOf(k) !== -1; })) return g.key;
    }
    return '';
  }

  /* ---------- finder matching ---------- */
  function norm(t) { return t.replace(/×/g, 'x').replace(/ft/g, '').replace(/\s+/g, ''); }
  function ballSizes(t) {
    var out = [], re = /sizes?\s*([0-9](?:[0-9\s,&\/\-–]|and)*)/g, m;
    while ((m = re.exec(t))) {
      var s = m[1];
      var r = s.match(/([0-9])\s*[-–]\s*([0-9])/);
      if (r) { for (var n = +r[1]; n <= +r[2]; n++) out.push(n); }
      (s.match(/[0-9]/g) || []).forEach(function (d) { out.push(+d); });
    }
    return out;
  }
  function finderMatch(card) {
    var f = state.finder; if (!f) return true;
    var t = card.getAttribute('data-t');
    if (f.kind === 'goal') return norm(t).indexOf(f.value) !== -1;
    return ballSizes(t).indexOf(+f.value) !== -1;
  }

  /* ---------- filtering ---------- */
  function inBand(card, band) {
    if (!band) return true;
    var p = +card.getAttribute('data-p'), b = band.split('-');
    return p >= +b[0] && (b[1] === '' || p < +b[1]);
  }
  function passes(card, skip) {
    if (skip !== 'group' && state.groups.length && state.groups.indexOf(card._g) === -1) return false;
    if (skip !== 'price' && !inBand(card, state.price)) return false;
    if (skip !== 'finder' && !finderMatch(card)) return false;
    return true;
  }
  function sorter(a, b) {
    if (state.sort === 'price-asc') return (+a.getAttribute('data-p')) - (+b.getAttribute('data-p')) || a._i - b._i;
    if (state.sort === 'price-desc') return (+b.getAttribute('data-p')) - (+a.getAttribute('data-p')) || a._i - b._i;
    if (state.sort === 'az') return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name')) || a._i - b._i;
    return a._i - b._i;
  }

  function apply(keepShown) {
    if (!keepShown) state.shown = perPage;
    var ordered = cards.slice().sort(sorter);
    var visible = ordered.filter(function (c) { return passes(c); });
    var frag = document.createDocumentFragment();
    ordered.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
    var vset = new Set(visible.slice(0, state.shown));
    cards.forEach(function (c) { c.hidden = !vset.has(c); });

    var total = visible.length;
    $('[data-esc-count]').textContent = total;
    var showN = $('[data-esc-show-n]'); if (showN) showN.textContent = 'Show ' + total + ' product' + (total === 1 ? '' : 's');
    $('[data-esc-empty]').hidden = total !== 0;
    var more = $('[data-esc-more]');
    var shown = Math.min(state.shown, total);
    more.hidden = total <= perPage && shown >= total;
    $('[data-esc-more-text]').textContent = 'Showing ' + shown + ' of ' + total;
    $('[data-esc-more-bar]').style.width = (total ? (shown / total * 100) : 0) + '%';
    var mb = $('[data-esc-more-btn]');
    mb.hidden = shown >= total;
    mb.textContent = 'Load ' + Math.min(perPage, total - shown) + ' more';

    // live counts
    groups.forEach(function (g) { g.live = 0; });
    cards.forEach(function (c) { if (c._g && passes(c, 'group')) groupByKey[c._g].live++; });
    $$('[data-esc-type-count]').forEach(function (el) { el.textContent = groupByKey[el.getAttribute('data-esc-type-count')].live; });
    $$('[data-esc-type-list] input').forEach(function (i) { i.checked = state.groups.indexOf(i.value) !== -1; });
    $$('[data-esc-tile]').forEach(function (b) { b.setAttribute('aria-pressed', state.groups.length === 1 && state.groups[0] === b.getAttribute('data-esc-tile') ? 'true' : 'false'); });
    $$('[data-esc-price-list] input').forEach(function (i) {
      i.checked = state.price === i.value;
      var n = cards.filter(function (c) { return passes(c, 'price') && inBand(c, i.value); }).length;
      i.parentNode.querySelector('[data-esc-pc]').textContent = n;
    });
    $$('.esc-sort__b').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sort') === state.sort ? 'true' : 'false'); });
    var sel = $('[data-esc-sort-select]'); if (sel) sel.value = state.sort;

    // active pills
    var act = $('[data-esc-active]'), pills = [];
    state.groups.forEach(function (k) { pills.push('<button type="button" data-rm="g:' + k + '">' + esc(groupByKey[k].label) + '<span aria-hidden="true">×</span><span class="esc-sr">Remove filter</span></button>'); });
    if (state.price) pills.push('<button type="button" data-rm="p">' + esc(bands[state.price]) + '<span aria-hidden="true">×</span><span class="esc-sr">Remove filter</span></button>');
    if (state.finder) pills.push('<button type="button" data-rm="f">' + esc(state.finder.label) + '<span aria-hidden="true">×</span><span class="esc-sr">Remove filter</span></button>');
    var n = pills.length;
    act.innerHTML = n ? pills.join('') + '<button type="button" class="esc-active__clear" data-rm="all">Clear all</button>' : '';
    act.hidden = !n;
    var badge = $('[data-esc-active-n]'); if (badge) { badge.textContent = n; badge.hidden = !n; }
    writeUrl();
  }

  /* ---------- url state ---------- */
  function writeUrl() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('type'); u.searchParams.delete('price'); u.searchParams.delete('sort');
      if (state.groups.length) u.searchParams.set('type', state.groups.join(','));
      if (state.price) u.searchParams.set('price', state.price);
      if (state.sort !== 'best') u.searchParams.set('sort', state.sort);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function readUrl() {
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.get('type')) state.groups = q.get('type').split(',').filter(function (k) { return groupByKey[k]; });
      if (q.get('price') && bands[q.get('price')]) state.price = q.get('price');
      if (['price-asc', 'price-desc', 'az'].indexOf(q.get('sort')) !== -1) state.sort = q.get('sort');
    } catch (e) {}
  }

  /* ---------- build UI after all cards are in ---------- */
  function setup() {
    cards = $$('[data-esc-card]', grid);
    cards.forEach(function (c, i) { c._i = i; });
    buildGroups();
    cards.forEach(function (c) {
      c._g = assign(c);
      if (c._g) {
        groupByKey[c._g].count++;
        var tag = c.querySelector('[data-esc-tag]');
        if (tag) { tag.textContent = groupByKey[c._g].label; tag.hidden = false; }
      }
    });
    var used = groups.filter(function (g) { return g.count > 0; }).sort(function (a, b) { return a.order - b.order; });

    // Keep menu-driven subcategory tiles rendered by Liquid (BikersWear behaviour).
    // Only build product-type tiles when no menu navigation tiles are present.
    var tiles = $('[data-esc-tiles]');
    var hasMenuTiles = tiles && tiles.querySelector('[data-esc-nav-item]');
    if (!hasMenuTiles && used.length >= 2) {
      tiles.innerHTML = used.map(function (g) {
        var first = cards.filter(function (c) { return c._g === g.key; })[0];
        var img = first && first.querySelector('.esc-card__img img');
        var src = img ? (img.getAttribute('src') || '').replace(/width=\d+/, 'width=240') : '';
        return '<li><button type="button" class="esc-tile" data-esc-tile="' + g.key + '" aria-pressed="false">' +
          '<span class="esc-tile__img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</span>' +
          '<span class="esc-tile__label">' + esc(g.label) + '</span><span class="esc-tile__n">' + g.count + '</span></button></li>';
      }).join('');
      $('[data-esc-types-wrap]').hidden = false;
      var list = $('[data-esc-type-list]');
      list.innerHTML = used.map(function (g) {
        return '<li><label><input type="checkbox" value="' + g.key + '"><span>' + esc(g.label) + '</span><em data-esc-type-count="' + g.key + '"></em></label></li>';
      }).join('');
      $('[data-esc-type-fieldset]').hidden = false;
    }
    var nojs = $('[data-esc-nojs-pages]'); if (nojs) nojs.hidden = true;
    readUrl();
    apply();
    if (state.groups.length || state.price) { /* coming back with filters: keep them */ }
  }

  /* ---------- load remaining pages (collections over 250 products) ---------- */
  function loadPages(done) {
    var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
    if (pages < 2) { done(); return; }
    var id = root.getAttribute('data-section-id');
    var base = new URL(window.location.href);
    var jobs = [];
    for (var k = 2; k <= Math.min(pages, 8); k++) {
      var u = new URL(base.pathname, base.origin);
      if (base.searchParams.get('sort_by')) u.searchParams.set('sort_by', base.searchParams.get('sort_by'));
      if (base.searchParams.get('preview_theme_id')) u.searchParams.set('preview_theme_id', base.searchParams.get('preview_theme_id'));
      u.searchParams.set('page', k); u.searchParams.set('section_id', id);
      jobs.push(fetch(u.toString()).then(function (r) { return r.text(); }).catch(function () { return ''; }));
    }
    Promise.all(jobs).then(function (htmls) {
      htmls.forEach(function (h) {
        if (!h) return;
        var doc = new DOMParser().parseFromString(h, 'text/html');
        doc.querySelectorAll('[data-esc-card]').forEach(function (c) { c.hidden = true; grid.appendChild(document.adoptNode(c)); });
      });
      done();
    });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var tile = t.closest('[data-esc-tile]');
    if (tile) {
      var k = tile.getAttribute('data-esc-tile');
      state.groups = (state.groups.length === 1 && state.groups[0] === k) ? [] : [k];
      apply();
      return;
    }
    var rm = t.closest('[data-rm]');
    if (rm) {
      var v = rm.getAttribute('data-rm');
      if (v === 'all') { state.groups = []; state.price = ''; state.finder = null; }
      else if (v === 'p') state.price = '';
      else if (v === 'f') state.finder = null;
      else state.groups = state.groups.filter(function (g) { return g !== v.slice(2); });
      apply();
      return;
    }
    if (t.closest('[data-esc-clear]')) { state.groups = []; state.price = ''; state.finder = null; apply(); return; }
    var sb = t.closest('.esc-sort__b');
    if (sb) { state.sort = sb.getAttribute('data-sort'); apply(); return; }
    if (t.closest('[data-esc-more-btn]')) {
      var before = state.shown;
      state.shown += perPage; apply(true);
      var next = cards.filter(function (c) { return !c.hidden; })[before];
      if (next) { var a = next.querySelector('.esc-card__title a'); if (a) a.focus({ preventScroll: true }); }
      return;
    }
    var pr = t.closest('[data-esc-price-list] input');
    if (pr) { state.price = (state.price === pr.value) ? '' : pr.value; apply(); return; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-esc-type-list] input')) {
      state.groups = $$('[data-esc-type-list] input').filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
      apply();
    }
    if (t.matches('[data-esc-sort-select]')) { state.sort = t.value; apply(); }
  });

  /* mobile filter panel */
  var panel = $('[data-esc-filters]'), opener = $('[data-esc-open-filters]');
  function openF() { panel.classList.add('is-open'); opener.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('esh-lock'); var c = $('.esc-filters__close', panel); if (c) c.focus(); }
  function closeF() { if (!panel.classList.contains('is-open')) return; panel.classList.remove('is-open'); opener.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('esh-lock'); opener.focus(); }
  if (opener) opener.addEventListener('click', openF);
  $$('[data-esc-close-filters]').forEach(function (b) { b.addEventListener('click', closeF); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });

  /* finder */
  var finder = $('[data-esc-finder]');
  if (finder) {
    var ages = $$('.esc-age', finder), cur = null;
    var gBtn = $('[data-esc-finder-goals]', finder), bBtn = $('[data-esc-finder-balls]', finder);
    var goalKey = (finder.getAttribute('data-goal-group') || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var ballKey = (finder.getAttribute('data-ball-group') || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var pick = function (b, focus) {
      ages.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
      cur = b;
      var g = b.getAttribute('data-goal'), gp = g.split('x');
      $('[data-esc-out="format"]', finder).textContent = b.getAttribute('data-format');
      $('[data-esc-out="goal"]', finder).textContent = gp[0] + ' × ' + gp[1] + 'ft';
      $('[data-esc-out="ball"]', finder).textContent = b.getAttribute('data-ball');
      gBtn.textContent = 'Show ' + gp[0] + ' × ' + gp[1] + 'ft goals';
      bBtn.textContent = 'Show size ' + b.getAttribute('data-ball') + ' balls';
      if (focus) b.focus();
    };
    ages.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = ages[(i + 1) % ages.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = ages[(i - 1 + ages.length) % ages.length];
        if (n) { e.preventDefault(); pick(n, true); }
      });
    });
    pick(ages.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || ages[0]);
    var go = function (kind) {
      var g = cur.getAttribute('data-goal'), gp = g.split('x');
      state.finder = kind === 'goal' ? { kind: 'goal', value: gp[0] + 'x' + gp[1], label: gp[0] + ' × ' + gp[1] + 'ft goals' } : { kind: 'ball', value: cur.getAttribute('data-ball'), label: 'Size ' + cur.getAttribute('data-ball') + ' balls' };
      var key = kind === 'goal' ? goalKey : ballKey;
      state.groups = groupByKey[key] ? [key] : [];
      apply();
      var r = $('.esc-results'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    gBtn.addEventListener('click', function () { go('goal'); });
    bBtn.addEventListener('click', function () { go('ball'); });
  }

  /* compare (max 3) */
  var picked = [];
  var tray = $('[data-esc-cmp]'), dlg = $('[data-esc-dialog]');
  function card(id) { return grid.querySelector('[data-id="' + id + '"]'); }
  function renderTray() {
    $$('[data-esc-cmp-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', picked.indexOf(b.closest('[data-esc-card]').getAttribute('data-id')) !== -1 ? 'true' : 'false'); });
    tray.hidden = !picked.length;
    $('[data-esc-cmp-list]').innerHTML = picked.map(function (id) {
      var c = card(id);
      return '<li><span>' + esc(c.getAttribute('data-name')) + '</span><button type="button" data-cmp-rm="' + id + '" aria-label="Remove from compare">×</button></li>';
    }).join('');
    var ob = $('[data-esc-cmp-open]'); ob.disabled = picked.length < 2; ob.textContent = 'Compare ' + picked.length + ' of 3';
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest('[data-esc-cmp-toggle]'); if (!b) return;
    var id = b.closest('[data-esc-card]').getAttribute('data-id'), i = picked.indexOf(id);
    if (i !== -1) picked.splice(i, 1); else if (picked.length < 3) picked.push(id); else { picked.shift(); picked.push(id); }
    renderTray();
  });
  tray.addEventListener('click', function (e) {
    var r = e.target.closest('[data-cmp-rm]'); if (r) { picked.splice(picked.indexOf(r.getAttribute('data-cmp-rm')), 1); renderTray(); }
    if (e.target.closest('[data-esc-cmp-clear]')) { picked = []; renderTray(); }
    if (e.target.closest('[data-esc-cmp-open]')) {
      var cols = picked.map(card);
      var row = function (label, fn) { return '<tr><th scope="row">' + label + '</th>' + cols.map(function (c) { return '<td>' + fn(c) + '</td>'; }).join('') + '</tr>'; };
      $('[data-esc-dialog-body]', dlg).innerHTML = '<table class="esc-ctable"><thead><tr><td></td>' + cols.map(function (c) {
        var img = c.querySelector('.esc-card__img img');
        return '<th scope="col">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" width="160" height="160">' : '') + '<a href="' + esc(c.querySelector('.esc-card__title a').getAttribute('href')) + '">' + esc(c.getAttribute('data-name')) + '</a></th>';
      }).join('') + '</tr></thead><tbody>' +
        row('Price', function (c) { return esc(c.querySelector('.esc-card__price').textContent.trim()); }) +
        row('Type', function (c) { return c._g ? esc(groupByKey[c._g].label) : '–'; }) +
        row('Details', function (c) { return $$('.esc-card__chips li', c).map(function (l) { return esc(l.textContent.trim()); }).join('<br>') || '–'; }) +
        '</tbody></table>';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
  });
  if (dlg) {
    $('[data-esc-dialog-close]', dlg).addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* hero link to the buying guide when this collection has one */
  var gl = $('[data-esc-guide-link]'); if (gl && document.getElementById('esc-guide')) gl.hidden = false;

  loadPages(setup);
})();